// src/modules/clinical-note-ai/utils/safeParseJsonFromModel.js

export const safeParseJsonFromModel = (rawContent) => {
  if (!rawContent) throw new Error('No content to parse');

  let text = Array.isArray(rawContent)
    ? rawContent
        .map((p) => (typeof p === 'string' ? p : (p && (p.text || p.content || '')) || ''))
        .join('')
    : String(rawContent);

  text = text.trim();

  if (text.startsWith('```')) {
    text = text.replace(/^```[a-zA-Z]*\s*/m, '');
    text = text.replace(/```$/m, '');
    text = text.trim();
  }

  const firstBrace = text.indexOf('{');
  const lastBrace = text.lastIndexOf('}');

  if (firstBrace === -1 || lastBrace === -1 || lastBrace <= firstBrace) {
    console.error('[safeParseJsonFromModel] No JSON object found:', text);
    throw new Error('No JSON object found in model response');
  }

  const jsonSlice = text.slice(firstBrace, lastBrace + 1);
  return JSON.parse(jsonSlice);
};
